<div class="flex flex-col space-y-4">
    <div class="overflow-hidden rounded border border-gray-200">
        <table class="w-full border-collapse text-sm">
            <thead>
                <tr class="border-b border-gray-200 bg-gray-100">
                    <th
                        class="px-4 py-3 text-left font-normal !text-tertiary-900"
                    >
                        Name
                    </th>
                    <th
                        class="px-4 py-3 text-left font-normal !text-tertiary-900"
                    >
                        Count
                    </th>
                    <th
                        class="px-4 py-3 text-left font-normal !text-tertiary-900"
                    >
                        Export
                    </th>
                </tr>
            </thead>
            <tbody>
                @for (
                    quickbooksReport of quickbooksReportOrder;
                    track quickbooksReport
                ) {
                    <tr class="border-b border-gray-100 last:border-b-0">
                        <td class="px-4 py-3 !text-tertiary-900">
                            {{ quickbooksReportsConfig[quickbooksReport].name }}
                        </td>
                        <td class="px-4 py-3">
                            <span class="!text-tertiary-900">{{
                                quickbooksReportsConfig[quickbooksReport].count
                            }}</span>
                        </td>
                        <td class="px-4 py-3">
                            @if (
                                quickbooksReportsConfig[quickbooksReport]
                                    .count === 0
                            ) {
                                <span class="!text-tertiary-900">N/A</span>
                            } @else {
                                <button
                                    type="button"
                                    class="cursor-pointer text-blue-600 hover:underline"
                                    (click)="export(quickbooksReport)"
                                >
                                    Export
                                </button>
                            }
                        </td>
                    </tr>
                }
            </tbody>
        </table>
    </div>
</div>
